// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-editor-zoom_and_breakpoint_controls__divider {\n  width: 1px;\n  height: 16px;\n  align-self: center;\n  background: #16161626;\n  margin-left: 6px;\n}\n", "",{"version":3,"sources":["webpack://./src/editor/zoom_and_breakpoint_controls.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,qBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".divider {\n  width: 1px;\n  height: 16px;\n  align-self: center;\n  background: colorBlackO15;\n  margin-left: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": "src-editor-zoom_and_breakpoint_controls__divider"
};
export default ___CSS_LOADER_EXPORT___;
